import { CrudApi } from './CrudApi';
import { EventAssessmentDataModel } from '../models/athlete/EventAssessmentDataModel';
import { PaginatedResponse, RepositoryQuery, QueryOptions, SportName } from '@/../types';
import { AthleteAssessmentDataModel, AthleteProfileModel, BAEventModel } from '@/models';
import { athleteAssessmentDataApi } from './AthleteAssessmentDataApi';
import { athleteApi } from './AthleteApi';
import { genderType, isNotEmpty } from '@/pipes';

class EventAssessmentDataApi extends CrudApi<EventAssessmentDataModel> {
	constructor(){
		super('eventAssessment', (obj) => new EventAssessmentDataModel().load(obj));
	}

    async findOne(query): Promise<EventAssessmentDataModel> {
        const options: QueryOptions = { limitPerPage: 1 };
        const response: PaginatedResponse<EventAssessmentDataModel> = await eventAssessmentDataApi.queryAll(query, options);
        if( response.docs.length === 0 ) return undefined;
        await response.docs[0].initialize();
        return response.docs[0];
    }
    async findOneByAthleteAndEvent(athleteId: string, eventId: string): Promise<EventAssessmentDataModel> {
        const query: RepositoryQuery<EventAssessmentDataModel> = { $match: {athleteId, eventId} };
        return await this.findOne(query);
    }

    async createOneForAthleteAndEvent(athleteId: string, event: BAEventModel): Promise<EventAssessmentDataModel> {
        const obj: EventAssessmentDataModel = new EventAssessmentDataModel();
        obj.athleteId = athleteId;
        obj.eventId = event.id;
        
        return obj;
    }
}

export const eventAssessmentDataApi = new EventAssessmentDataApi();